import React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllMarksBySubTaskGuid,
  SetMarksManager,
} from "../../../../Redux/Reducers/Manager/Marks";
import { useParams } from "react-router-dom";
import InputAHSF from "../../../../Components/InputAHSF";
import SharedDiv from "../../../../Components/SharedDiv/SharedDiv";
import "./style.css";
import { GetQuestionSelectableTagsList } from "../../../../Redux/Reducers/Manager/Dropdowns/QuestionSelectableTagsList";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
const MarksTable = (props) => {
  const dispatch = useDispatch();
   const lang = useSelector((state) => state.languageReducer.Language);
  const { subTaskId } = useParams();
  const MarksManager = useSelector((state) => state.MarksManager.MarksManager);
  const loadingMarksManager = useSelector(
    (state) => state.MarksManager.loadingMarksManager
  );
  const QuestionSelectableTagsList = useSelector(
    (state) => state.QuestionSelectableTagsList.QuestionSelectableTagsList
  );

  const [marksList, setMarksList] = useState(MarksManager);
  const getMarksData = async () => {
    const data = await dispatch(
      GetAllMarksBySubTaskGuid({
        subTaskId: subTaskId,
      })
    );
    if (data?.payload.length > 0) {
      // dispatch(SetMarksManager([...data.payload]));
      setMarksList([...data.payload]);
    }
  };
  console.log(MarksManager, "MarksManager", marksList);
  useEffect(() => {
    getMarksData();
    dispatch(GetQuestionSelectableTagsList());
  }, []);
  useEffect(() => {
    dispatch(SetMarksManager(marksList));
  }, [marksList]);
  return !loadingMarksManager ? (
    <>
      <SharedDiv
        showTitle={true}
        titleNameAR=" معايير التقييم "
        titleNameEN="Evaluation criteria"
        lang={lang}
        child={[
          <div className="table-Container">
            <table className="">
              <thead className="head-table" dir="rtl"></thead>
              <tbody>
                {MarksManager &&
                  MarksManager.length > 0 &&
                  Object.entries(
                    MarksManager.reduce((groups, item) => {
                      const key = item.questionGroupId;
                      if (!groups[key]) groups[key] = [];
                      groups[key].push(item);
                      return groups;
                    }, {})
                  ).map(([groupId, groupItems]) => (
                    <React.Fragment key={groupId}>
                      {/* عنوان المجموعة */}
                      <tr className="group-row">
                        <td colSpan={2} className="groupName">
                          {lang=="en"?groupItems[0]?.questionGroupNameEn:groupItems[0]?.questionGroupName}
                        </td>
                      </tr>
                      <tr className="head-table">
                        <th className="col-standard">{lang=="en"?"Standard":"المعيار"}</th>
                        <th className="col-score">{lang=="en"?"Mark (100%)":"العلامة (100%)"}</th>
                      </tr>
                      {/* الأسئلة داخل المجموعة */}
                      {groupItems.map((item, index) => (
                        <tr key={item.questionId || index}>
                          <td>{lang=="en"?item.questionNameEn:item.questionName}</td>
                          <td>
                            <AllDropDownsAHSF
                              fieldsName="totalMarks"
                              hidelable={true}
                              lang={lang}
                              addPercent={true}
                              show={true}
                              disabled={props.disabled}
                              dropdownType="normal"
                              arrayOoptionList={QuestionSelectableTagsList}
                              KeyText={"tags"}
                              KeyValue={"tags"}
                              // KeyValue={"eV_ST_QuestionSelectableTagsId"}
                              value={item?.evalMark}
                              onChange={(e) =>
                                setMarksList((prev) =>
                                  prev.map((m) =>
                                    m.questionId === item.questionId
                                      ? {
                                          ...m,
                                          evalMark: Number(e.target.value),
                                        }
                                      : m
                                  )
                                )
                              }
                            />
                          </td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>,
        ]}
      />
    </>
  ) : (
    ""
  );
};

export default MarksTable;
